module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPopup),
      expression: "showPopup"
    }],
    staticClass: "ve-popover macro",
    style: (_vm.style)
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.val),
      expression: "!val"
    }]
  }, [_c('div', {
    staticClass: "ve-pop-header"
  }, [_vm._v("Макрос")]), _vm._v(" "), _c('div', {
    staticClass: "ve-pop-body"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('ul', [_vm._l((_vm.arr), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.addItem(item)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }), _vm._v(" "), _c('li', {
    staticClass: "ve-divider"
  }), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.check()
      }
    }
  }, [_vm._v("Проверить")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.copyForTemplate()
      }
    }
  }, [_vm._v("Копировать для шаблона")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.updatePopupDisplay()
      }
    }
  }, [_vm._v("Отмена")]), _vm._v(" "), _c('li', {
    staticClass: "ve-divider"
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fullscreen),
      expression: "!fullscreen"
    }],
    on: {
      "click": function($event) {
        return _vm.toFullScreen()
      }
    }
  }, [_vm._v("Полный экран")])], 2)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.val),
      expression: "val"
    }]
  }, [_c('div', {
    staticClass: "ve-pop-header"
  }, [_vm._v("Изменить макрос")]), _vm._v(" "), _c('div', {
    staticClass: "ve-pop-body"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "ve-input",
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": "5"
    },
    model: {
      value: (_vm.newVal),
      callback: function($$v) {
        _vm.newVal = $$v
      },
      expression: "newVal"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ve-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateMacro
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('button', {
    staticClass: "ve-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updatePopupDisplay
    }
  }, [_vm._v("Отменить")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-576ef061","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vueditor/macro.vue
// module id = 829
// module chunks = 1